<template>
  <div>
    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col md="4" offset-md="4">
          <v-content class="text-center pa-10" v-if="!authenticationError">
            <v-progress-circular
              :size="50"
              color="#3497c5"
              indeterminate
            ></v-progress-circular>
            <div class="pb-5 pt-5">
              <p
                style="
                  color: #666666;
                  font-size: 25px;
                  font-family: Assistant;
                  font-weight: 600;
                "
              >
                Please wait while we sign you in...
              </p>
              <p
                style="color: #333333; font-size: 17px; font-family: Assistant"
              >
                This may take a moment.
              </p>
            </div>
            <v-img
              class="login-logo"
              src="static/senso-learn-sign-in-screen-owl.png"
            ></v-img>
          </v-content>
          <v-content class="text-center pa-10" v-else>
            <div class="pt-5">
              <p
                style="
                  color: #333333 !important;
                  font-size: 25px !important;
                  font-family: Assistant;
                  font-weight: 600 !important;
                "
              >
                Whoops! Invalid user details...
              </p>
              <p
                style="
                  color: #666666 !important;
                  font-size: 16px !important;
                  font-family: Assistant;
                  font-weight: 600 !important;
                "
              >
                Please check your details and log in again.
              </p>
            </div>
            <v-card-actions class="login-btn pb-5">
              <v-btn color="dddd" class="login-button" @click="backToLogin">
                <v-icon small class="mr-2">fa fa-arrow-left</v-icon>
                Go Back
              </v-btn>
            </v-card-actions>
            <v-img
              class="login-logo"
              src="static/senso-learn-invalid-user.png"
            ></v-img>
          </v-content>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'Authentication',
  components: {},
  data: () => ({
    authenticationError: false,
    params: {},
  }),
  mounted() {
    const { userId, provider, providerId, state } =
      this.$router.currentRoute.params;
    this.params = {
      user: userId,
      provider: provider,
      'provider-code': providerId,
      'mfa-session': false,
      state: state,
    };
    if (!userId || !provider || !providerId || !state)
      this.authenticationError = true;
    else this.ssoAuthentication();
  },
  methods: {
    ssoAuthentication() {
      this.$store
        .dispatch('loginWithSSO', this.params)
        .then((resp) => {
            this.getProfile();
        })
        .catch((err) => {
          this.loading = false;
          if (err.response.status == 403) {
            this.authenticationError = true;
          }
        });
    },
    getProfile() {
      this.$store
        .dispatch('profile')
        .then((resp) => {
          switch (this.$store.getters.level) {
            case 1:
              this.$router.push('/super-admin/companies');
              break;
            case 2:
              this.$router.push('/admin/users');
              break;
            case 4:
              this.$router.push('/partner/users');
              break;
            case 5:
              this.$router.push('/partner/users');
              break;
            case 6:
              this.$router.push('/super-admin/billinglist');
              break;
            case 7:
              this.$router.push('/courses');
              break;
            default:
              this.$router.push('/courses');
              break;
          }
        })
        .catch((err) => {
          
        });
    },
    backToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>
<style scoped>
.v-content {
  flex: 0 0 auto !important;
}

.v-application p {
  margin: 0;
  font-family: Source Sans Pro, Roboto, Open Sans, sans-serif !important;
  font-weight: 600 !important;
  color: black !important;
}

.login-button {
  width: 150px;
}
.login-btn:hover {
  color: #fff;
}
</style>

<head>
  <link href='https://fonts.googleapis.com/css?family=Assistant' rel='stylesheet'>
</head>
